export default {"src":"/_next/static/image/public/img/menu.4bd38a737640e174c51aa4d6bd3ac5f3.svg","height":21,"width":24};